import './style.css';

export const Steps = (props) => {
  return (
    <div class="steps width-100 flex flex-column align-center justify-center">
      <div class="flex width-100" style={{ width: '70%' }}>
        {props.data.map((item, index) => {
          return (
            <div class="flex align-center" style={{ flex: index < props.data.length - 1 ? 1 : '' }}>
              <div class="relative">
                <div
                  class={`border ${props.value >= item.value ? 'border-c-primary' : 'border-c-secondary'}`}
                  style={{ 'border-width': '2px', width: '12px', height: '12px', 'border-radius': '50%' }}
                ></div>
              </div>
              {index < props.data.length - 1 && (
                <div
                  class={`border flex-auto ${
                    props.value >= item.value + 1 ? 'border-c-primary' : 'border-c-secondary'
                  }`}
                  style={{ 'border-width': '1.5px' }}
                ></div>
              )}
            </div>
          );
        })}
      </div>

      <div class="flex width-100 margin-t-XS">
        {props.data.map((item) => {
          return (
            <div class={`flex flex-auto justify-center ${props.value >= item.value ? 'color-D' : ''}`}>
              <div>{item.label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
